import { createActions } from 'redux-actions';
import { identity } from 'ramda';

const actionsDefinition = {
  ADD_PERMISSIONS: identity,
  CLEAR_PERMISSIONS: identity,
};

export const { addPermissions, clearPermissions } = createActions(actionsDefinition);
